import { z } from 'zod/v3';
import { transformNullish } from '../../../../common/utils/schema';

export const AlgorithmTargetItemFormDataSchema = z.object({
  id: transformNullish<number>(z.number(), -1),
  confidentialityStatus: z.boolean().nullish(),
  dimensionId: transformNullish<number | undefined>(z.number(), undefined),
  dimensionCode: transformNullish<string>(z.string(), ''),
  dimensionName: transformNullish<string>(z.string(), ''),
  indicatorId: transformNullish<number | undefined>(z.number(), undefined),
  indicatorCode: transformNullish<string>(z.string(), ''),
  indicatorName: transformNullish<string>(z.string(), ''),
});
